import { AnalysisConfigurationFeatureSectionDTO } from "@models/platform-analysis/entities/steps/feature";
import { isEqual } from "lodash";

export const getFeatureSelectDeselectResult = ({
  isDeselect,
  isUpdateEssential,
  originalSelections,
  targetSectionId,
  targetSubSectionId,
  targetFeatureId,
}: {
  isDeselect?: boolean;
  isUpdateEssential?: boolean;
  originalSelections?: AnalysisConfigurationFeatureSectionDTO[];
  targetSectionId?: string;
  targetSubSectionId?: string;
  targetFeatureId?: string;
}) => {
  if (!originalSelections) return [];

  return originalSelections.map((section) => {
    const shouldUpdateSection =
      !targetSectionId || section.id === targetSectionId;
    if (!shouldUpdateSection) return section;

    let totalSelectionDelta = 0;
    const newSection = {
      ...section,
      subSections: section.subSections.map((subSection) => {
        const { features, id } = subSection;
        const shouldUpdateSubSection =
          !targetSubSectionId || id === targetSubSectionId;

        if (!shouldUpdateSubSection) return subSection;

        const updatedFeatures = features?.map((feature) => {
          const { isSelected, isEssential } = feature;
          const shouldUpdateFeature =
            !targetFeatureId || feature.id === targetFeatureId;

          if (!shouldUpdateFeature) {
            return feature;
          }

          totalSelectionDelta += isDeselect
            ? isSelected
              ? -1
              : 0
            : isSelected
            ? 0
            : 1;

          return {
            ...feature,
            isSelected: !isDeselect,
            isEssential: isUpdateEssential
              ? !isEssential
              : isDeselect
              ? false
              : isEssential,
          };
        });

        return {
          ...subSection,
          features: updatedFeatures,
        };
      }),
    };

    newSection.totalSelectedFeature += totalSelectionDelta;
    return newSection;
  });
};

export const isEqualFeatureSelectionsWithStoredData = (
  storedData?: AnalysisConfigurationFeatureSectionDTO[],
  newData?: AnalysisConfigurationFeatureSectionDTO[],
) => isEqual(pickRelevantToCompare(storedData), pickRelevantToCompare(newData));

const pickRelevantToCompare = (
  sections?: AnalysisConfigurationFeatureSectionDTO[],
) => {
  return sections?.map((section) => ({
    isSelected: section.isSelected,
    subSections: section.subSections.map((ss) => ({
      features: ss.features?.map((f) => ({
        isSelected: f.isSelected,
        isEssential: f.isEssential,
      })),
    })),
  }));
};
